import e from "../managers/braze-instance.js";
import r from "../../shared-lib/braze-shared-lib.js";
import G, { STORAGE_KEYS as o } from "../managers/storage-manager.js";
export function enableSDK() {
  new G.ne(null, !0).remove(o.ae);
  const a = r.xt.Ft;
  new r.qt(a, r.D).br(a.$t.oe, a.se), e.destroy(!1), e.le(!1);
}
